import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import AccordionHeader from './header';

class Accordion extends Component {

    state = {
        isExpanded: this.props.isExpanded
    };

    componentWillReceiveProps(nextProps) {

        if (this.props.isExpanded !== nextProps.isExpanded) {

            this.setState({
                isExpanded: nextProps.isExpanded
            });

        }

    }

    handleClick = () => {

        this.setState({
            isExpanded: !this.state.isExpanded
        });

        if (this.props.onClick) {

            this.props.onClick(!this.state.isExpanded);

        }

    };

    render = () => {

        const isOpenClassName = this.state.isExpanded ?
            'is-open' :
            'is-closed';

        const accordionClassName = `accordion ${this.props.accordionId} ${isOpenClassName}`;

        return (
            <section className={accordionClassName}>
                <AccordionHeader
                    isExpanded={this.state.isExpanded}
                    onClick={this.handleClick}
                    secondaryNode={this.props.secondaryHeaderNode}
                    title={this.props.title}
                />
                {this.state.isExpanded && <div className='accordion-body'>{this.props.body}</div>}
            </section>

        );

    }

}

Accordion.displayName = 'Accordion';
Accordion.propTypes = {
    accordionId: PropTypes.string.isRequired,
    body: PropTypes.node.isRequired,
    isExpanded: PropTypes.bool,
    onClick: PropTypes.func,
    secondaryHeaderNode: PropTypes.node,
    title: PropTypes.node.isRequired
};
Accordion.defaultProps = {
    isExpanded: false
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/shared/components/accordion/index.js